import * as Sentry from '@sentry/react';

// Same DSN as the Rails SDK (sentry.rb). Sentry DSNs are intended to be
// public — they identify the project, not a secret.
const DSN = 'https://d1a9ce4f10211e3637380ceb39cf9319@o4511452765945856.ingest.us.sentry.io/4511452768894976';

function meta(name) {
  const el = document.querySelector(`meta[name="${name}"]`);
  return el ? el.getAttribute('content') : null;
}

export function initSentry() {
  const env = meta('app:environment') || 'production';
  if (env !== 'production') return;

  Sentry.init({
    dsn: DSN,
    environment: env,
    // Performance tracing off by default — flip to ~0.1 if you want it.
    tracesSampleRate: 0,
    // Don't ship request bodies / cookies / headers (Rails SDK is configured
    // the same way: PHI/regulated data flows through this app).
    sendDefaultPii: false,
    // Drop a few noisy errors that almost always come from extensions or
    // benign autoplay rejections rather than our code.
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
      'AbortError: The play() request was interrupted',
      'NotAllowedError: play() failed because the user',
    ],
  });

  const userId = meta('app:user_id');
  if (userId) Sentry.setUser({ id: userId });
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
